import { Transform } from '@warp-drive/legacy/serializer/transform';

export default class ColorHexTransform extends Transform {
  deserialize(serialized) {
    return serialized;
  }

  serialize(deserialized, options) {
    if (deserialized === '#aN') {
      if ('defaultValue' in options) {
        return options.defaultValue;
      } else {
        return null;
      }
    }
    return deserialized;
  }
}
